/**
 * Converts a tuple [x, y] to an object of keys and values { [x]: y }
 *
 * E.g:
 *  const obj = arrayToObject([
 *      [1, 5],
 *      [2, 6],
 *      [3, 7],
 * ]);
 * obj is now {
 *  1: 5,
 *  2: 6,
 *  3: 7,
 * }
 *
 * @param array - The array tuple to convert
 * @returns An object
 */
export function arrayToObject<ArrayEle extends [any, any]>(array: ArrayEle[]): { [key in ArrayEle[0]]: ArrayEle[1] } {
    return array.reduce(
        (result, entry) => ({
            ...result,
            [entry[0]]: entry[1],
        }),
        {},
    ) as { [key in ArrayEle[0]]: ArrayEle[1] };
}
